import { Injectable } from '@angular/core';
import { triggerFn } from '@wms/app/core';
import { ProjectService, DatabaseService } from '@wms/services';

@Injectable({
  providedIn: 'root'
})
export class QueryBuilderService {
  appRunUrl: any;

  constructor(private projectService: ProjectService, private databaseService: DatabaseService) { }

  executeQuery(options: any, success: any, error: any) {
    this.makeExecuteQuery(options, success, error);
    /*If the project is not yet deployed,
    deploy the project and then execute the query.*/
    this.appRunUrl = this.projectService.getAppDeployedUrl();
    if (this.appRunUrl) {
      this.makeExecuteQuery(options, success, error);
    } else {
      this.projectService.getAppRunURL().then(() => {
        this.appRunUrl = this.projectService.getAppDeployedUrl();
        if (this.appRunUrl) {
          this.makeExecuteQuery(options, success, error);
        }
      });
    }
  }

  makeExecuteQuery(options: any, success: any, error: any) {
    this.databaseService.executeCustomQuery({
      "projectID": this.projectService.getProjectId(),
      "dataModelName": options.databaseName,
      "page": options.page,
      "size": options.size,
      "data": {
        "queryString": options.query,
        "parameters": options.queryParams || [],
        "nativeSql": options.nativeSql,
        'type': 'SELECT'
      },
      "service": options.prefabName ? "" : "services",
      "url": options.prefabName ? (this.appRunUrl + "/prefabs/" + options.prefabName) : this.appRunUrl
    }, (response: any) => {
      if (response.errors) {
        triggerFn(error, response);
      } else {
        triggerFn(success, response);
      }
    }, (response: any) => {
      triggerFn(error, response);
    });
  };
}
